export const AUTH_DATA_STORAGE_KEY = 'authData';
export const MODE_STORAGE_KEY = 'mode';
